let pdfMakeInstance: any = null;

export async function getPdfMake() {
  if (pdfMakeInstance) {
    return pdfMakeInstance;
  }

  const pdfMakeModule = await import('pdfmake/build/pdfmake');
  const pdfFontsModule = await import('./pdf-make/vfs_fonts');

  pdfMakeInstance = pdfMakeModule.default;
  pdfMakeInstance.vfs = pdfFontsModule.default;

  return pdfMakeInstance;
}
